module.exports = __webpack_public_path__ + "static/media/previous.8e4b593a.svg";